import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { makeStyles } from '@mui/styles';
import { palette } from '@livable/saas-react-components';
import helpers from 'src/styles/helpers';
import sections from 'src/styles/sections';
const useStyles = makeStyles(_objectSpread(_objectSpread(_objectSpread({}, helpers), sections), {}, {
  header: {
    display: 'flex',
    justifyContent: ' space-between',
    '& .MuiPaper-root': {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between'
    }
  },
  searchSection: {
    width: '420px',
    padding: '20px 20px'
  },
  searchSectionInput: {
    '& .MuiInputBase-root': {
      minHeight: '48px'
    }
  },
  tableFullNameCell: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '230px'
  },
  tableFullNameText: {
    marginRight: '8px'
  },
  tableEmailCell: {
    width: '150px',
    textOverflow: 'ellipsis',
    overflow: 'hidden'
  },
  avatar: {
    backgroundColor: palette.info.main,
    border: '1px solid',
    borderRadius: '50%',
    height: '32px',
    color: palette.common.white,
    fontSize: '13px',
    fontFamily: palette.fontFamilies.poppins,
    fontWeight: '600',
    flexShrink: '0',
    lineHeight: '32px',
    // marginRight: '-10px',
    marginRight: '5px',
    textAlign: 'center',
    width: '32px'
  },
  accessTooltip: {
    '& .MuiTooltip-tooltip': {
      minWidth: '330px',
      maxWidth: '430px'
    }
  },
  accessTooltipContainer: {
    width: '100%',
    '& .tooltip-header': {
      background: 'none',
      display: 'flex',
      justifyContent: 'space-between',
      borderBottom: "1px solid ".concat(palette.shades[300]),
      alignItems: 'baseline'
    },
    '& .tooltip-content': {
      padding: '10px 0'
    }
  },
  fullAccessDesciption: {
    padding: '0 10px'
  },
  mainList: {
    margin: '0px 0px 0px 0px',
    listStyle: 'none',
    lineHeight: '24px'
  },
  listItem: {
    fontSize: '16px',
    position: 'relative',
    display: 'flex',
    margin: '6px 0',
    paddingRight: '10px',
    alignItems: 'end',
    '&:before': {
      position: 'absolute',
      left: '-15px',
      top: '-10px',
      content: '""',
      display: 'block',
      borderLeft: '1px solid #ddd',
      height: '26px',
      borderBottom: '1px solid #ddd',
      width: '14px'
    },
    '&:after': {
      position: 'absolute',
      left: '-15px',
      bottom: '-16px',
      content: '""',
      display: 'block',
      borderLeft: '1px solid #ddd',
      height: ' 100%'
    },
    '&.rootListItem': {
      margin: '0px 0px 0px -20px',
      '&:before': {
        display: 'none'
      },
      '&:after': {
        display: 'none'
      }
    },
    '&:last-child': {
      '&:after': {
        display: 'none'
      }
    }
  }
}));
export default useStyles;